module.exports = __webpack_public_path__ + "static/media/PricingDQWorkspace2.4ac22585.png";